import app from 'flarum/app';
import Field from './Field';
import Switch from 'flarum/components/Switch';

/* global m */

export default class ShortAnswer extends Field {
    whiteListConfigProperties() {
        return super.whiteListConfigProperties().concat([
            'email',
            'regex',
        ]);
    }

    configure() {
        return [
            m('.Form-group', Switch.component({
                state: this.getConfig('email', false),
                onchange: this.setConfig('email'),
                disabled: this.disabled,
            }, app.translator.trans('kilowhat-formulaire.forum.template-editor.email'))),
            m('.Form-group', m('.FormulaireInputWithLabel', {
                className: this.getConfig('regex') ? 'FormulaireInputWithLabel--with-value' : '',
            }, [
                m('input.FormControl', {
                    type: 'text',
                    value: this.getConfig('regex'),
                    onchange: m.withAttr('value', this.setConfig('regex')),
                    disabled: this.disabled,
                }),
                m('label', app.translator.trans('kilowhat-formulaire.forum.template-editor.regex')),
            ])),
        ];
    }

    fill() {
        return m('input.FormControl', {
            type: this.getConfig('email', false) ? 'email' : 'text',
            id: this.uniqueFieldId(),
            className: this.validationErrorsForThisField() ? 'in-error' : '',
            value: this.getSubmission(),
            onchange: m.withAttr('value', this.setSubmission.bind(this)),
            disabled: this.isFillDisabled(),
        });
    }
}
